import { ofType } from "redux-observable";
import { of } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { selectRankingCurrentPosition, selectRankingSelectedLanguage, } from "../../../selectors/selectRankInfo";
import { utilRanking } from "../../../utils/utilRanking";
import { actionCoopXpHighscoresReceived, TypeActionRanking } from "../actionRanking";
export var epicCoopXpRankingByPosition = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionRanking.CoopXpHighSocresPositionRequest), switchMap(function (action) {
        var state = state$.value;
        var position = action.position
            ? action.position
            : selectRankingCurrentPosition(state);
        var language = selectRankingSelectedLanguage(state);
        var url = utilRanking.getRankingCoopXpUrlByPosition(position, language ? language.languageCode : undefined);
        return utilRanking.ajaxGetRequest(url);
    }), retry(), switchMap(function (res) {
        return of(actionCoopXpHighscoresReceived(res));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/ranking/epics/epicCoopXpRankingByPosition.ts
// module id = 2119
// module chunks = 3